import { FONT_SIZE, colorPalette } from '@dermloop/ui/util';
import { createGlobalStyle } from 'styled-components';

export const fontFamily = 'Inter, Helvetica, Arial, sans-serif';

export const GlobalStyles = createGlobalStyle`
  body {
    padding:0;
    font-size: ${FONT_SIZE}px;
    background-color:${colorPalette.gray[50]};
    overflow-y:scroll;
    font-family: ${fontFamily};
  }
  html, body, #root {
    height:100%;
    display:flex;
    width:100%;
    margin: 0;
  }

  #root > div {
    z-index:unset;
  }

  #root > div > div{
    z-index:unset;
  }

  span[data-inline], div[data-inline] {
    display:inline;
  }
`;
